import { render, staticRenderFns } from "./visPersonalAssessment.vue?vue&type=template&id=5dfd0ec4"
import script from "./visPersonalAssessment.vue?vue&type=script&lang=js"
export * from "./visPersonalAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports